const BigHeading = ({ title }) => {
  return <h1 className='heading heading--bigger'>{title}</h1>;
};

export default BigHeading;
